import React from 'react';

const ShowIcon = (props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g fill='currentColor'>
          <path d='M16 9c5.084 0 9.66 2.597 11.942 6.777.077.14.077.307 0 .447C25.66 20.404 21.083 23 16.001 23c-5.083 0-9.659-2.596-11.943-6.774-.077-.142-.077-.307 0-.448C6.34 11.597 10.916 9 16 9zm0 2.154c-2.978 0-5.4 2.174-5.4 4.846s2.422 4.846 5.4 4.846 5.4-2.174 5.4-4.846-2.422-4.846-5.4-4.846zM16 13c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3c0-.394.076-.77.215-1.116.217.312.578.516.985.516.662 0 1.2-.538 1.2-1.2 0-.407-.204-.768-.515-.985.344-.139.72-.215 1.115-.215z' />
        </g>
      </g>
    </svg>
  );
};

export default ShowIcon;
